import React from "react";
import styled from "styled-components";
type buttonType = {
  outline?: boolean;
  label: string;
  background?: string;
  borderColor?: string;
  color?: string;
  className: any;
  onClick: () => void;
};
const Button = (props: buttonType) => {
  const {
    outline,
    label,
    background,
    borderColor,
    color,
    onClick,
    className,
    ...rest
  } = props;

  const _borderColor =
    borderColor === "secondary"
      ? "#ff4d84"
      : borderColor === "primary"
      ? "#0078d8"
      : "black";

  if (outline) {
    return (
      <OutlineButton
        $borderColor={_borderColor}
        className={`p-1 sm-text ${className}`}
      >
        {label || ""}
      </OutlineButton>
    );
  }
  return (
    <NormalButton
      $borderColor={_borderColor}
      className={`p-1 sm-text ${className}`}
    >
      {label || ""}
    </NormalButton>
  );
};

export default Button;

const OutlineButton = styled.div<{ $borderColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.5px solid
    ${(props) =>
      props?.$borderColor ? props?.$borderColor : "rgb(180,180,180)"};
  border-radius: 6px;
`;
const NormalButton = styled.button<{ $borderColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: none;
  border: 0.5px solid
    ${(props) =>
      props?.$borderColor ? props?.$borderColor : "rgb(180,180,180)"};
  border-radius: 6px;
`;
